import { ReactNode, ReactText, createContext, } from 'react';
import { actionType } from '../hooks/useGlobal';
import { NavigateFunction, useOutletContext } from 'react-router-dom';
import { IObject } from '../../constants/interface';

type skinType = 'dark' | 'blue';
interface IGlobal {
  /** 菜单样式类型 */
  skinType: skinType;
  /** 修改密码 */
  changePassword: boolean;
  /** 初始化接口加载完成 */
  isInit: boolean;
  /** 菜单是否加载完成 */
  isMenu: boolean;
  /** 用户信息是否加载完成 */
  isUserInfo: boolean;
  /** 租户信息是否加载完成 */
  isTenant: boolean;
  /** 应用信息是否加载完成 */
  isApp: boolean;
}
export interface IUserInfo {
  name: string;
  avatar: string;
  userAccountId: string;
  [key: string]: any;
}
export interface ITenant {
  tenantId: string;
  tenantName: string;
  avatar: string;
  [key: string]: any;
}
interface IMenu {
  name?: string;
  path?: string;
  icon?: string;
  resourceId?: string;
  children?: IMenu[];
}
interface IAppItem {
  systemInfo: string;
  systemName: string;
  urlPrefix: string;
  systemId: string;
  systemCode: string;
  [key: string]: any;
}
export interface IApp {
  current: IAppItem;
  list: IAppItem[];
}
export interface IRouteTabs {
  name: string;
  path: string;
  urlPrefix?: string;
  query?: any;
}
export interface IEnumItem {
  label: ReactNode;
  value: ReactText | boolean;
}
export interface IEnum {
  [key: string]: {
    name: string;
    items: IEnumItem[];
  };
}
/** 水印菜单项 */
export interface WatermarkMenuItem {
  name?: string;
  path?: string;
  resourceId?: string;
};
/** 水印配置 */
export interface IWatermarkConfig {
  /** 状态 */
  watermarkStatus?: string;
  /** 位置 */
  position?: string;
  /** 方向 */
  direction?: string;
  /** 是否显示时间 */
  displayTimeState?: string;
  /** 水印文字类型 */
  contentType?: string;
  /** 水印文字 */
  customContent?: string;
  /** 水印菜单 */
  menu?: WatermarkMenuItem[];
}
export interface IBaseContext {
  /** 全局状态 */
  global: IGlobal;
  /** 用户信息 */
  userInfo?: IUserInfo;
  /** 租户信息 */
  tenant?: ITenant;
  /** 菜单 */
  menu: IMenu[];
  /** 应用信息 */
  app?: IApp;
  /** 帮助文档链接和页面之间的映射 */
  menuHelp?: IObject
  /** 枚举信息 */
  enumData?: IEnum;
  /** 系统参数 */
  configData?: IObject;
  /** 项目名称 */
  projectName?: string;
  /** 跳转页面方法 */
  navigate?: NavigateFunction;
  /** 路由信息 */
  routes: any[];
  /** tabs标签信息 */
  routeTabs: IRouteTabs[];
  /** 权限 */
  authority: any[];
  /** 需要打开新页面的路由 */
  fullPages: string[];
  /** 服务端系统配置 */
  serviceConfig?: {
    /** oss前缀 */
    appOssEndpoint?: string;
  };
  /** 水印配置 */
  watermarkConfig?: IWatermarkConfig,
}
export interface ILayoutContext extends IBaseContext {
  dispatch: (type: actionType, payload?: any) => any;
}

export default createContext<ILayoutContext>({
  global: {
    skinType: 'dark',
    changePassword: false,
    isInit: false,
    isMenu: false,
    isUserInfo: false,
    isApp: false,
    isTenant: false,
  },
  projectName: '',
  dispatch: () => {},
  routes: [],
  menu: [],
  routeTabs: [],
  authority: [],
  fullPages: [],
});

export function useLayoutContext() {
  const global = useOutletContext<ILayoutContext>();
  // 提供给子组件的全局方法
  const dispatch = (type: actionType, payload?: any): any => {
    switch (type) {
      case 'globalData':
        return global;
      case 'authorityList':
        return global.authority;
      case 'isAuthority':
        if (typeof payload === 'string') {
          return global.authority.includes(payload);
        }
        if (Array.isArray(payload)) {
          for (let i = 0; i < payload.length; i++) {
            const authorityStr = payload[i];
            if (global.authority.includes(authorityStr)) return true;
          }
          return false;
        }
        break;
      case 'isRoute':
        return !!global.routes.find(v => v.path === payload);
      default:
        global?.dispatch?.(type, payload);
    }
  };
  return {
    ...global,
    dispatch,
  };
}
